import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { EventType } from "../../Types";
import { Button } from "../../utils/Button";
import { AudioButtonContainer } from "../AudioButtonContainer";

export class PauseLayer extends Phaser.GameObjects.Container {

    private boundingRectangle: Phaser.Geom.Rectangle;
    private canBeClosed: boolean;
    private soundLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.canBeClosed = false;

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x000000, 0.7);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const w = 405;
        const h = 450;

        this.boundingRectangle = new Phaser.Geom.Rectangle(-w / 2, -h / 2, w, h);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        // EL SONIDO

        const soundBackground = new Phaser.GameObjects.Image(this.scene, 0, -150, "texture_atlas_1", "card_description_background");
        scaledItemsContainer.add(soundBackground);

        this.soundLabel = new Phaser.GameObjects.Text(scene, 70, soundBackground.y, text.SOUND_ON[lan], {fontFamily: "AlmendraBold", color: "#663227", fontSize: "40px",  wordWrap: { width: 260, useAdvancedWrap: true }});
        this.soundLabel.setOrigin(1, .5);
        scaledItemsContainer.add(this.soundLabel);

        const audioButtonContainer = new AudioButtonContainer(this.scene, this.onSoundButtonClick, this);
        audioButtonContainer.x = 130;
        audioButtonContainer.y = soundBackground.y;
        scaledItemsContainer.add(audioButtonContainer);

        // EL RESTART
        const restartBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "card_description_background");
        scaledItemsContainer.add(restartBackground);

        const restartLabel = new Phaser.GameObjects.Text(scene, this.soundLabel.x, 0, text.RESTART[lan], {fontFamily: "AlmendraBold", color: "#663227", fontSize: "40px"});
        restartLabel.setOrigin(1, .5);
        scaledItemsContainer.add(restartLabel);

        const restartButton = new Button(this.scene, audioButtonContainer.x, 0, "texture_atlas_1", "btn_restart");
        restartButton.setInflationTween(1.1);
        restartButton.onDown(this.onRestart, this);
        scaledItemsContainer.add(restartButton);

        // EL EXIT
        const exitBackground = new Phaser.GameObjects.Image(this.scene, 0, -soundBackground.y, "texture_atlas_1", "card_description_background");
        scaledItemsContainer.add(exitBackground);

        const exitLabel = new Phaser.GameObjects.Text(scene, this.soundLabel.x, -soundBackground.y, text.HOME[lan], {fontFamily: "AlmendraBold", color: "#663227", fontSize: "40px"});
        exitLabel.setOrigin(1, .5);
        scaledItemsContainer.add(exitLabel);

        const exitButton = new Button(this.scene, audioButtonContainer.x, -soundBackground.y, "texture_atlas_1", "btn_exit");
        exitButton.setInflationTween(1.1);
        exitButton.onDown(this.onExit, this);
        scaledItemsContainer.add(exitButton);

        if (GameConstants.DEBUG) {
            const debugGraphics = new Phaser.GameObjects.Graphics(this.scene);
            debugGraphics.lineStyle(2, 0x00ff00);
            debugGraphics.strokeRectShape(this.boundingRectangle);
            scaledItemsContainer.add(debugGraphics);
        }

        this.scene.input.on("pointerdown", this.onPointerDown, this);

        this.scene.time.delayedCall(150, () => this.canBeClosed = true, [], this);
    }

    private onPointerDown(): void {

        if (!this.canBeClosed || !this.scene) {
            return;
        }
  
        let x = this.scene.input.activePointer.x;
        let y = this.scene.input.activePointer.y;

        x -= GameConstants.GAME_WIDTH / 2;
        y -= GameConstants.GAME_HEIGHT / 2;

        y /= GameVars.scaleY;

        if (!this.boundingRectangle.contains(x, y)) {
            GameVars.eventsDispatcher.dispatchEvent(new CardCrawl.Event(EventType.GAME_RESUMED, []));
        }
    }

    private onSoundButtonClick(): void {

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        if (GameVars.gameData.muted) {
            this.soundLabel.text = text.SOUND_OFF[lan];
        } else {
            this.soundLabel.text = text.SOUND_ON[lan];
        }
    }

    private onRestart(): void {
        
        GameManager.enterBoardScene();

        AudioManager.playSound("btn_click");
    }

    private onExit(): void {
        
        GameManager.enterSplashScene();

        AudioManager.playSound("btn_click");
    }
}
